<template>
  <div>
    <input
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
        required
    />
  </div>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    modelValue: {  // Используем modelValue для v-model
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: 'Введите значение',
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
</style>
